import { useContext } from 'react';

import { AccessContext, type AccessContextType } from '@/entities/user/providers/accessContext';

/**
 * Access the authenticated user + permission helpers. Only valid under
 * `<AccessProvider>` *after* it has resolved a session — the provider never
 * renders children without a user, so the null case is a programming error.
 */
export const useAccess = (): AccessContextType => {
  const context = useContext(AccessContext);
  if (!context) {
    throw new Error('useAccess() must be used inside <AccessProvider> (authenticated subtree)');
  }
  return context;
};
